import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { AnnualReviewSalesDepositsEditMode } from '~bank-annual-review/types/SalesDeposits'

export const annualReviewSalesDepositsEditModeQueryOptions = (id: number) =>
  queryOptions<AnnualReviewSalesDepositsEditMode>({
    queryKey: ['annual-review-sales-deposits-edit-mode', id],
    queryFn: () => Request.post(Request.urls.bank.annualReviewSalesDepositsEditMode, { id }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
